import React from 'react';

// Crédito de rodapé, presente em todas as telas (login, dashboard, admin).
function BrandCredit() {
  return (
    <p className="brand-credit">
      Desenvolvido por{' '}
      <a href="https://routerz.com.br" target="_blank" rel="noopener noreferrer">
        RouterZ Tecnologia
      </a>
    </p>
  );
}

export default BrandCredit;
